import { Badge } from '@folio/components';
import type { Tone } from '@folio/components/ui/tone';
import type { ClaimManagementStateDto } from 'korint-sdk';
import { useTranslation } from 'react-i18next';

const STATUS_TONE: Record<string, Tone> = {
  DRAFT: 'warning',
  INSTRUCTION: 'info',
  SETTLEMENT: 'primary',
  CLOSED: 'success',
  DISCARDED: 'muted',
};

// Only one module drives the lifecycle at a time: externalIntake hands over to documents.
const activeSubStatus = ({ subStatuses }: Pick<ClaimManagementStateDto, 'subStatuses'>) =>
  subStatuses?.externalIntake ?? subStatuses?.documents;

export const claimTypeLabel = ({
  claimTypeLabel,
  claimType,
}: Pick<ClaimManagementStateDto, 'claimTypeLabel' | 'claimType'>) =>
  claimTypeLabel?.slice(0, 2).join(' > ') || claimType;

export function ClaimStatusBadge({
  claim,
}: {
  claim: Pick<ClaimManagementStateDto, 'status' | 'subStatuses'>;
}) {
  const { t } = useTranslation();
  const subStatus = activeSubStatus(claim);
  const status = t(`claimsList.status.${claim.status}`, claim.status);

  return (
    <Badge variant="light" tone={STATUS_TONE[claim.status] ?? 'info'}>
      {subStatus ? `${status} · ${t(`claimsList.status.${subStatus}`, subStatus)}` : status}
    </Badge>
  );
}
